import { render, staticRenderFns } from "./CandidateSimilar.vue?vue&type=template&id=1b517e22&lang=pug"
import script from "./CandidateSimilar.vue?vue&type=script&lang=js"
export * from "./CandidateSimilar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports